import { ReviewPoolItem, ReviewPoolGroup } from '../types/reviewPool';

/**
 * 审核池共享类型与分组工具（原 P6.2 mock 数据已随去 mock 删除；此处仅保留仍被消费的
 * ExistingSiteOption 类型与 groupReviewItems 分组函数）。
 */

/** 已有揽收站点（AB 映射 / 合并 的目标候选形状） */
export interface ExistingSiteOption {
  id: number;
  name: string;
  address: string;
  contact?: string;
  dock?: string;
}

/**
 * 组合分组 + 排序（PRD：analysisHash 一致的组合在一起，组内按最早时间参与排序、
 * 组间按最早时间倒序）。
 */
export function groupReviewItems(items: ReviewPoolItem[]): ReviewPoolGroup[] {
  const map = new Map<string, ReviewPoolItem[]>();
  items.forEach((it) => {
    const arr = map.get(it.addressAnalysisHash) || [];
    arr.push(it);
    map.set(it.addressAnalysisHash, arr);
  });

  const groups: ReviewPoolGroup[] = Array.from(map.entries()).map(([analysisHash, groupItems]) => {
    const sorted = [...groupItems].sort(
      (a, b) => new Date(a.firstOrderTime).getTime() - new Date(b.firstOrderTime).getTime(),
    );
    return { analysisHash, items: sorted, earliestTime: sorted[0].firstOrderTime };
  });

  // 组间按最早时间倒序
  groups.sort((a, b) => new Date(b.earliestTime).getTime() - new Date(a.earliestTime).getTime());
  return groups;
}
